import isEmpty from 'lodash/isEmpty';
export var urlValue = (label, value) => value !== true && isEmpty(value) ? null : {
  [label]: value
};
export var arrayUrlValues = (label, values) => isEmpty(values) || isEmpty(label) ? null : {
  [label.toLowerCase()]: values.join(',')
};